import { AxiosResponse } from "axios";
import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";

const ENDPOINT = "/options";

export class FetchOptionsCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "get";
    params = null;

    public async execute(): Promise<AxiosResponse> {
        var res = await this.executeCommand(null, null, this.params);
        return res;
    }
}
